/* eslint-disable */
import getShowcasePath from '@/js/common/Domain/Service/getShowcasePath';

$(function () {
	var VirtualPhone = Backbone.Epoxy.View.extend({
		model: new (Backbone.Model.extend({
			defaults: {
				phoneNumber: '',
				isLink: false
			}
		}))(),
		el: ".js-virtual-phone-text",
		bindings: {
			":el": "text:phoneNumber"
		},
		initialize: function () {
			if(this.$el.is("a")){
				this.model.set("isLink", true);
				this.bindings[":el"] = "attr:{href:phoneNumber}"
			}
			this.getPhoneNumber()
		},
		getPhoneNumber: function () {
			var self = this;
			$.get(`${getShowcasePath()}/getVirtualPhone`).success(function (data) {
				if(data.success && data.data){
					var phoneStr = self.model.get("isLink") ? "tel:" : "";
					phoneStr +=  data.data;
					self.model.set('phoneNumber', phoneStr)
				}
			})
		}
	});
	new VirtualPhone();
});
